
(function () {
const targetTag = 'form-embed'

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && node.tagName.toLowerCase() === targetTag) {
        // Ensure shadow root is available
        if (node.shadowRoot) {
          injectStyle(node.shadowRoot);
        }
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true })

function injectStyle(shadowRoot) {
  // Only inject once
  if (!shadowRoot.querySelector('style[data-injected="true"]')) {
    const style = document.createElement('style')
    style.setAttribute('data-injected', 'true')
    style.textContent = `
 
   section[class*="_inline_"] section[class*="_formContainer_"]{
     max-width: 100% !important;
     width: 100% !important;
   }


  div[class*="_withError"] > input{
    border-bottom: 1px solid red !important;
  }


   input[type="text"],
   input[type="tel"]{
    border: none !important;
    border-bottom: 1px solid #000 !important;
    box-shadow: 0 0 0 1 #b0b0b033 !important;
    font-family: canada-type-gibson, sans-serif !important;
    border-radius: 0px !important;
   }

   label{
    font-size: 11px !important;
    font-family: canada-type-gibson, sans-serif !important;
    text-transform: uppercase !important;
   }

   h2 {
    letter-spacing: -.025rem !important;
    font-weight: 44 !important;
    font-style: italic !important;
   }

   p{
    font-size: 1.3rem !important;
    line-height: 1.8rem !important;
    letter-spacing: 0px !important;
    font-family: "Times New Roman", Times, serif !important;
   }

   textarea[class*="_textArea"]{
    border-radius: 0px !important;
   }


    button[class*="_selectToggle"]{
    border-radius: 0px !important;
    font-size: 12px !important;
    letter-spacing: 0.72px !important;
    text-align: center !important;
    text-transform: uppercase !important;
    font-family: canada-type-gibson, sans-serif !important;
    color: #000 !important;
    background: rgba(0, 0, 0, 0) !important;
    border: 1px solid #000 !important;
    min-height: 2rem !important;
    text-decoration: none !important;
    font-weight: normal !important;
  }

  button[type="submit"] {
  all: revert !important;
   border-radius: 0px !important;
   font-size: 12px !important;
    line-height: 11px !important;
    letter-spacing: 0.72px !important;
    text-align: center !important;
    text-transform: uppercase !important;
    height: 30px !important;
    width: 100% !important;
    padding: 9px 30px !important;
    font-family: canada-type-gibson, sans-serif !important;
    color: #000 !important;
    background: rgba(0, 0, 0, 0) !important;
    border: 1px solid #000 !important;
    min-height: 2rem !important;
    text-decoration: none !important;
    font-weight: normal !important;
    
  }

  button[aria-disabled="true"]{
    background-color: #000 !important;
  }

span[class*="_spinner_"]{
    display:inline-block !important;

}

`
    shadowRoot.appendChild(style)
  }
}

})();

